import React from 'react'

const Close = () => {
  return (
    <svg
      fill='none'
      height='30'
      viewBox='0 0 24 24'
      width='30'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 22.454c5.774 0 10.454-4.68 10.454-10.454 0-5.774-4.68-10.455-10.454-10.455C6.226 1.545 1.545 6.226 1.545 12S6.226 22.454 12 22.454z'
        stroke='var(--search__icon__stroke)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M7.455 7.455l9.09 9.09M16.546 7.455l-9.091 9.09'
        stroke='var(--search__icon__stroke)'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Close
